var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeRightTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12189",
    "data-name": "Group 12189",
    transform: "translate(-15.674 -592.674)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_612",
    "data-name": "Ellipse 612",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(15.674 592.674)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check_box_FILL0_wght300_GRAD0_opsz24",
    d: "M150.93-802.017l7.166-7.166-1.123-1.123-6.043,6.043-3.038-3.038-1.123,1.123Z",
    transform: "translate(-127.878 1407.836)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeRightTick);
export default __webpack_public_path__ + "static/media/orange_right_tick.583041731990df3c1176fe085f5f08df.svg";
export { ForwardRef as ReactComponent };